import API from '@aws-amplify/api';
import Auth from '@aws-amplify/auth';

export default async function disableCognitoUserMFA(username: string) {
  const apiName = 'AdminQueries';
  const path = '/disableUserMFA';
  const myInit = {
    body: {
      username: username,
    },
    headers: {
      'Content-Type': 'application/json',
      Authorization: `${(await Auth.currentSession())
        .getAccessToken()
        .getJwtToken()}`,
    },
  };
  try {
    return await API.post(apiName, path, myInit);
  } catch (errors) {
    console.warn(errors);
  }
}
